import {fetchBasicUrlGetJson, fetchBasicJsonPostJson, fetchBasicJsonPost} from '@/script/common';

export default {
	getData: (page, itemsPerPage, filter, settings) => { // get all templates
		var parameters = {
			page: page,
			pageSize: itemsPerPage
		};
		return fetchBasicJsonPostJson('/DrugTreatmentTemplate/GetDataTableData', {
			...settings,
			data: Object.assign(filter, parameters)
		});
	},
	getTemplates: departmentCode =>
		fetchBasicUrlGetJson('/DrugTreatmentTemplate/GetTemplates',
			{ data: { departmentCode } }
		)
	,
	GetTemplate: id =>
		fetchBasicJsonPostJson('/DrugTreatmentTemplate/GetTemplate',
			{ data: { id } }
		)
	,
	add: item => {
		return fetchBasicJsonPost('/DrugTreatmentTemplate/Add', {
			data: item
		});
	},
	edit: item => {
		return fetchBasicJsonPost('/DrugTreatmentTemplate/Edit', {
			data: item
		});
	},
	delete: item => {
		return fetchBasicJsonPost('/DrugTreatmentTemplate/Delete', {
			data: item
		});
	}
};
